module.exports = __webpack_public_path__ + "img/small-title.598f96c9.png";